module.exports = __webpack_public_path__ + "img/map.53cc79c1.jpg";